import { type Entity } from '@backstage/catalog-model';
import { isComponentType } from '@backstage/plugin-catalog';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { isGitlabAvailable } from '@immobiliarelabs/backstage-plugin-gitlab';

const isServiceComponent = isComponentType('service');

const isGitlabServiceEntity = (entity: Entity) =>
  isServiceComponent(entity) && isGitlabAvailable(entity);

const gitlabEntityContent = EntityContentBlueprint.make({
  name: 'driveline-gitlab',
  params: {
    path: '/gitlab',
    title: 'GitLab',
    filter: isGitlabServiceEntity,
    loader: () =>
      import('./GitlabEntityContent').then(module => (
        <module.GitlabEntityContent />
      )),
  },
});

export const gitlabEntityContentModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [gitlabEntityContent],
});
